import * as React from "react";
import type { SVGProps } from "react";
const SvgCarFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 15h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2M18 15h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2M9.76 15.97a9.4 9.4 0 0 0 2.24.28 9.4 9.4 0 0 0 2.24-.28 1 1 0 0 0-.48-1.94 7.2 7.2 0 0 1-3.52 0 1 1 0 0 0-.48 1.94"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.98 19h-6v.49A1.52 1.52 0 0 1 7.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V19a1 1 0 0 1-.87-.55l-.79-1.58A3 3 0 0 1 2 15.53v-3.06a3 3 0 0 1 .32-1.34l.563-1.134L2.385 9H1a1 1 0 0 1 0-2h2a1 1 0 0 1 .808.411L4.37 5.73A4 4 0 0 1 8.16 3h7.68a4 4 0 0 1 3.79 2.74l.56 1.673A1 1 0 0 1 21 7h2a1 1 0 0 1 0 2h-1.385l-.498.996.563 1.134a3 3 0 0 1 .32 1.34v3.06a3 3 0 0 1-.32 1.34l-.79 1.58A1 1 0 0 1 20 19h-.02v.49A1.52 1.52 0 0 1 18.49 21h-2a1.52 1.52 0 0 1-1.51-1.51zm4.4-2 .51-1a1 1 0 0 0 .11-.45v-3.06a1 1 0 0 0-.11-.45l-.416-.837A28.4 28.4 0 0 1 12.12 12H12a29.7 29.7 0 0 1-7.472-.801l-.418.841a1 1 0 0 0-.11.45v3.06a1 1 0 0 0 .11.45l.51 1zm-7.27-6.94c2.226.037 4.445-.21 6.606-.731L17.73 6.34a2 2 0 0 0-1.89-1.37H8.16a2 2 0 0 0-1.89 1.37l-.984 2.983c2.198.519 4.453.767 6.714.737z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCarFront;
